{
  "name": "web-installer-portal",
  "version": "3.2026.15",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4201",
    "build": "ng build",
    "build:dev": "ng build -c development",
    "build:prod": "ng build -c production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:run": "ng test --watch=false"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^22.1.5",
    "@angular/compiler": "^22.1.5",
    "@angular/core": "^22.1.5",
    "@angular/forms": "^22.1.5",
    "@angular/platform-browser": "^22.1.5",
    "@angular/platform-browser-dynamic": "^22.1.5",
    "@angular/router": "^22.1.5",
    "@ant-design/icons-angular": "^22.1.0",
    "@jsverse/transloco": "^8.4.0",
    "@microsoft/clarity": "^1.0.2",
    "@opentelemetry/api": "^1.9.1",
    "@opentelemetry/auto-instrumentations-web": "^0.67.0",
    "@opentelemetry/exporter-trace-otlp-http": "^0.222.0",
    "@opentelemetry/resources": "^2.11.0",
    "@opentelemetry/sdk-trace-web": "^2.11.0",
    "@opentelemetry/semantic-conventions": "^1.43.0",
    "@supabase/supabase-js": "^2.116.0",
    "dayjs": "^1.11.23",
    "echarts": "^6.1.0",
    "firebase": "^12.18.0",
    "localforage": "^1.10.0",
    "mqtt": "^5.15.2",
    "ng-zorro-antd": "^22.0.1",
    "ngx-echarts": "^22.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuidv7": "^1.2.1"
  },
  "devDependencies": {
    "@angular/build": "^22.1.7",
    "@angular/cli": "^22.1.7",
    "@angular/compiler-cli": "^22.1.5",
    "jsdom": "^30.0.1",
    "less": "^4.9.1",
    "prettier": "^3.9.6",
    "typescript": "~6.0.3",
    "vitest": "^4.0.8",
    "wrangler": "^4.129.1"
  }
}
